<template>
    <div id="details-modal-wrapper">
        <div class="modal fade" id="confi-details" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content confi-modal">
                    <div class="confi-modal__container">
                        <svg class="confi-modal__close-button" data-dismiss="modal" height="26" width="27" @click="detachModal()">
                            <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                        <div class="confi-modal__main-img">
                            <transition mode="out-in">
                                <img
                                        :src="'https://bilder.weberbuero.de/frontend/images/materials/large/' + modalSelectedColor.img + '.jpg'"
                                        @load="setModalKey"
                                        v-show="modalSelectedColor.img === modalKey"
                                >
                            </transition>
                            <div class="confi-modal__controls">
                                <div class="homepage-swiper__prev"
                                     :class="{ 'disabled' : modalSelectedColor.id == colorArray[0]}"
                                     @click="slidePrev">
                                    <svg class="homepage-swiper__arrow homepage-swiper__arrow--prev"><use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
                                </div>
                                <div class="homepage-swiper__next"
                                     :class="{ 'disabled' : modalSelectedColor.id == colorArray[lastColorKey]}"
                                     @click="slideNext">
                                    <svg class="homepage-swiper__arrow homepage-swiper__arrow--next"><use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
                                </div>
                            </div>
                        </div>

                        <div class="confi-modal__infos">
                            <div class="confi-modal__infos--left">
                                <div class="confi-modal__thumb--big"
                                     :style="{ backgroundImage: 'url(https://bilder.weberbuero.de/frontend/images/materials/thumbs/' + modalSelectedColor.img + '.jpg)' }"
                                ></div>
                                <h4 class="confi-modal__name">{{modalSelectedColor.name}}</h4>
                                <span class="confi-modal__number">{{modalSelectedColor.img}}</span>
                            </div>
                            <div class="confi-modal__infos--right" v-html="modalDetailsText">
                            </div>
                        </div>
                    </div>

                    <div class="confi-modal__bottom">
                        <ul v-if="activeAttributes && activeAttributes[swiperColor]">
                            <li v-for="(color, key) in activeAttributes[swiperColor].values"
                                class="confi-modal__thumb"
                                :class="{'confi-modal__thumb--active': key === modalSelectedColor.id }"
                                :style="{ backgroundImage: 'url(https://bilder.weberbuero.de/frontend/images/materials/thumbs/' + color.split(' ')[0] + '.jpg)' }"
                                @click="selectModalColor(key)">
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailsModal",

        props:{
            activeAttributes: Object,
            colorArray: Array,
            swiperColor: String,
            modalSelectedColor: Object
        },

        data(){
            return {

                modalKey:null
            }
        },

        inject: {
            itemId: {
                default: null
            }
        },

        computed:{
            activeColorPosition()
            {
                return this.colorArray.indexOf(this.modalSelectedColor.id);
            },
            lastColorKey()
            {
                return this.colorArray.length - 1;
            },
            currentVariation() {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
            modalDetailsText()
            {
                return this.findProperty(11);
            },
        },

        methods:{
            detachModal(){
                $("#details-modal-wrapper").detach().appendTo('.configurator');
            },

            findProperty(propID)
            {
                if (this.currentVariation && typeof this.currentVariation.variationProperties != 'undefined' && this.currentVariation.variationProperties.length > 0)
                {
                    const props = this.currentVariation.variationProperties[0].properties;
                    const propData = props.find(p => p.id === propID);
                    if (propData && propData.values && propData.values.value)
                    {
                        return propData.values.value;
                    }
                }
                return "";
            },

            selectModalColor(id)
            {
                this.$emit("selectModalColor",id);

            },

            slideNext()
            {
                if (this.modalSelectedColor.id !== this.colorArray[this.colorArray.length - 1])
                {
                    const nextKey = this.colorArray[this.activeColorPosition + 1];

                    this.selectModalColor(nextKey);
                }
            },

            slidePrev()
            {
                if (this.modalSelectedColor.id !== this.colorArray[0])
                {
                    const prevKey = this.colorArray[this.activeColorPosition - 1];

                    this.selectModalColor(prevKey);
                }
            },

            setModalKey()
            {
                this.modalKey = this.modalSelectedColor.img;
            },

        },

    }
</script>

